<!-- Author: Wilson Pilco Nunez -->
<!-- Email: wilsonaux1@gmail.com -->
<!-- Created at: 2026-01-29 18:57 -->
<!-- Description:  -->
<template>
  <div>
    <table>
      <tbody>
        <tr>
          <th>Profesional:</th>
          <td>{{ quote.employee_name }}</td>
        </tr>
        <tr>
          <th>Duración:</th>
          <td>{{ quote.duration }} min.</td>
        </tr>
        <tr>
          <th>Comentario:</th>
          <td>{{ quote.commentary }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
// script content
export default {
  name: "QuoteTag",
  components: {
    //
  },

  // directives

  props: {
    quote: {
      default: () => ({}),
    }
  },

  data: () => ({
    //
  }),

  computed: {
    //
  },

  // watch: {},

  mounted() {
    //
  },

  methods: {
    //
    //
    //
  }
};
</script>
<style scoped></style>

